import type { Ref } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
  onValueChange: (value: string) => void;
  onValueBlur?: () => void;
  valueRef?: Ref<HTMLInputElement>;
  disabled?: boolean;
  errorMessage?: string;
  labelKey?: string;
  helpKey?: string;
}

export default function LmsIntervalFields({
  value,
  onValueChange,
  onValueBlur,
  valueRef,
  disabled = false,
  errorMessage,
  labelKey = "validity_interval_in_days",
  helpKey = "validity_interval_help",
}: Props) {
  const { t } = useTranslation();
  return (
    <TextField
      fullWidth
      label={t(labelKey)}
      type="number"
      value={value}
      onChange={(event) => onValueChange(event.target.value)}
      onBlur={onValueBlur}
      inputRef={valueRef}
      disabled={disabled}
      inputProps={{ min: 0, step: 1 }}
      error={Boolean(errorMessage)}
      helperText={errorMessage || t(helpKey)}
    />
  );
}
